import React from 'react'
import styled from 'styled-components'
import { Head } from 'react-static'

import ImageFixedHeight from '../../common/ImageFixedHeight'

import steps from '../../../images/zebra2.jpg'

const Wrapper = styled.div`
	width: 100%;
	min-height: 100vh;
	position: relative;
	background-color: #f3f3f3;
	background: url(${steps}) repeat;
	padding: 0;
	text-align: center;

	.inner {
		padding: 25px;

		@media screen and (min-width: 801px) and (max-width: 1919px) {
			padding: 50px;
		}

		@media screen and (min-width: 1920px) {
			padding: 100px;
		}
	}

	.loading-component {
		margin-top: 0;
	}

	.image-background {
		margin: 0;
		border-radius: 0;
	}

	.people-bio {
		color: ${props => props.theme.main.bg};
		max-width: ${props => props.theme.main.maxWidth}em;
		margin: 0 auto;
		padding: 1em;
		background-color: #fff;
		border-radius: 3px;

		.people-bio-main {
			background-color: #f7f7f7;
			font-weight: 300;
			line-height: 1.6;
			padding: 1em;
			margin: 0 auto 2em;
			max-width: 27em;
			font-style: italic;
			border-radius: 3px;
		}

		img {
			width: 100%;
		}

		a {
			color: ${props => props.theme.secondary.bg2};
		}

		h3 {
			color: ${props => props.theme.secondary.bg3};
			font-size: 2.2em;
			margin: 0.8em auto;
		}

		p {
			font-size: 1.2em;
			text-align: center;
			margin-bottom: 1em;
		}

		@media screen and (min-width: 501px) {
			margin-top: 0;

			p {
				text-align: left;
			}
		}

		@media screen and (min-width: 801px) {
			margin: 0 auto;
			text-align: left;

			.people-bio-main {
				padding: 2em;
				margin: 0 0 2em;
			}

			h3 {
				margin-top: 0;
			}
		}

		@media screen and (min-width: 801px) {
			padding: 2em;
		}
	}

	.people-bio-links {
		margin-top: 2em;

		h4 {
			text-transform: uppercase;
			font-size: 1.2em;
		}
	}
`

const RichContent = styled.div`
	iframe {
		margin-top: 1em;
	}

	.ql-video {
		width: 100%;
		height: calc(56.25vw - 46px);

		@media screen and (min-width: 801px) and (max-width: 1919px) {
			height: calc(56.25vw - 17em);
			max-height: 32em;
		}

		@media screen and (min-width: 1920px) {
			width: 56em;
			height: 31.5em;
		}

	}
`

const PeopleBio = ({ data }) => (
  <Wrapper>
  	<Head>
  		<title>{data.name}</title>
  		<meta name="description" content={data.blurb} />
  	</Head>
    <ImageFixedHeight src={data.url} heightPercent={50}/>
    <div className="inner">
      <div className="people-bio">
        <h3>{data.name}</h3>
        <p className="people-bio-main">"{data.blurb}"</p>
        <RichContent dangerouslySetInnerHTML={{ __html: data.bio }} />
      </div>
    </div>
  </Wrapper>
)

export default PeopleBio


// WEBPACK FOOTER //
// /opt/build/repo/src/components/pages/people/PeopleBio.js